<template>
  <v-alert
    elevation="2"
    class="px-4"
    variant="tonal"
    border="top"
    border-color="success"
  >
    <h1 v-if="false" class="text-center display-2 my-8 font-weight-bold">
      Collaboration
    </h1>
    <div class="pa-8">
      <div class="my-8">
        <h2>Advising and Talks</h2>
        <div class="my-8">
          <v-chip label x-large class="mr-2 mb-2">
            <h3 class="font-weight-regular">Team</h3>
          </v-chip>
          <v-chip label x-large class="mr-2 mb-2">
            <h3 class="font-weight-regular">Product</h3>
          </v-chip>
          <v-chip label x-large class="mr-2 mb-2">
            <h3 class="font-weight-regular">Architecture</h3>
          </v-chip>
        </div>
      </div>
      <div class="my-8">
        <h2>Algorithms</h2>
        <div class="my-8">
          <v-chip label x-large class="mr-2 mb-2">
            <h3 class="font-weight-regular">National Level</h3>
          </v-chip>
        </div>
      </div>
      <div class="mt-8">
        <h2>Systems Architecture</h2>
        <div class="mt-8">
          <SkillLogosComponent />
        </div>
      </div>
    </div>
  </v-alert>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import SkillLogosComponent from './SkillLogosComponent.vue';

export default defineComponent({
  name: 'SkillsComponent',
  components: {
    SkillLogosComponent,
  },
});
</script>
